import './ShowMatch.css';
import React, { useState } from 'react';
import { Card } from 'antd';
import Match from './Match';
import SelectMatch from './SelectMatch';

const ShowMatch: React.FC = () => {

    const [ numMatch, setNumMatch ] = useState(1);
    const onChange = (value: any) => {
        setNumMatch(value);
    };

    return (
        <div>
            <Card title="Affichage des matchs" className="Card">
                    <SelectMatch onChange={onChange}/>
                    <Match numMatch={numMatch}></Match>
            </Card>
        </div>
    )
}
export default ShowMatch;
